import {action, computed, makeObservable, observable} from "mobx"
import axios from "axios"
import Preferences from "../../Shared/Preferences/Preferences";
import {defaultShortcuts} from "../../Shared/Preferences/hooks/useShortcuts";
import {t} from "../../I18n/i18n"

class ControleStore {
    @observable skip = []
    @observable app_id = ""
    @observable history = []
    @observable shortcuts = []
    @observable mesures = []
    @observable analysisFlags = []
    @observable tensionImportantGravityPreselection = false
    edit_prescription = false
    possible_examens = [
        {id: 0, title: "Fond d'oeil", default: true},
        {id: 1, title: "OCT", default: true},
        {id: 2, title: "Champ visuel", default: true},
        {id: 3, title: "Angiographie", default: true},
        {id: 4, title: "Topographie de cornée", default: true}
    ];

    @action setMesures(mesures) {
        this.mesures = mesures
        this.analysisFlags = this.getAnalysisFlags(mesures)
    }

    constructor() {
        this.loadPossibleExamens()
        makeObservable(this)
        this.getTextualShortcuts()
    }


    getTextualShortcuts = () => {
        Preferences.get('textual_shortcuts').then(shortcuts => {
            this.shortcuts = [...JSON.parse(shortcuts), ...defaultShortcuts] ?? []
        })
    }

    @action addHistory(id) {
        this.history.push(id)
    }

    @action backToHistory() {
        return this.history.pop()
    }

    @computed get hasHistory() {
        return (this.history.length > 0)
    }

    loadPossibleExamens() {
        axios.get('/admin/possible_examens/examens').then((response) => {
            this.possible_examens = this.possible_examens.concat(response.data.examens)
        })
    }

    getAnalysisFlags (mesures = []) {
        const flags = new Set();
        this.tensionImportantGravityPreselection=false

        mesures.forEach((mesure) => {
            // Pression intraoculaire
            if (mesure.od_tension > 21 || mesure.og_tension > 21) {
                flags.add(t("GENERAL_SUMMARY_PANEL.TENSION_TOO_HIGH"));
                if(mesure.od_tension > 30 || mesure.og_tension > 30){
                    this.tensionImportantGravityPreselection=true
                }
            }

            // Réfraction subjective
            if (mesure.typedemesure_id === 12) {
                const validAcuities = [null, "", "0.9", "1", "1.0", "12", "16", "1.2", "1.20", "1.25", "1.6", "1.5", "15"];

                if (!validAcuities.includes(mesure.og_av_loin) || !validAcuities.includes(mesure.od_av_loin)) {
                    flags.add(t("GENERAL_SUMMARY_PANEL.LOW_VISUAL_ACUITY"));
                }

                if (mesure.od_sphere < -6 || mesure.og_sphere < -6) {
                    flags.add(t("GENERAL_SUMMARY_PANEL.SPHERE_TOO_LOW"));
                }
            }
        });

        return Array.from(flags);
    };
}

let store = new ControleStore
global.ControleStore = store
export default store